import {h, Fragment, Component} from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import {route} from "preact-router";
import PFeed from "../../../services/prematch-feed";
import Ticket from "../utils/ticket-logic.jsx";
import BetBuilder from "../../../services/betbuilder";

import * as P from "../mobile-templates/event.jsx";

import FullSite from "./full-site";


export default function PrematchEvent(props) {
	return <FullSite class="bg-slate-300 text-slate-950 dark:bg-transparent dark:text-inherit"><PrematchEventPage key={props.eventId} {...props} /></FullSite>
}

export class PrematchEventPage extends Component {
	state = {
		sport: null, 
		category: null, 
		tournament: null, 
		event: null, 
		odds: [], 
		currentTab: -1
	}
	componentWillMount() {
		const {sportId, categoryId, tournamentId, eventId} = this.props;
		PFeed.getMenu((tag, menu) => {
			const sport = PFeed.menu['/sport/'+sportId];
			const category = sport.sub['/category/'+sportId+'/'+categoryId];
			const tournament = category.sub['/tournament/'+sportId+'/'+categoryId+'/'+tournamentId];
			
			this.setState({sport, category, tournament});
			
			PFeed.callTournamentMono(tournament.id, {}, () => {
				const event = PFeed.NStorage.get('/event/'+eventId);
				this.setState({event: event})
				
				PFeed.callEvent('/event/'+eventId, {}, (tag, odds) => {
					this.setState({
						odds: this.groupMarketsByName(Object.values(odds).sort((a, b) => a.order - b.order)),
						currentTab: (event.categories[0] || {id: -1, name: 'All'}).id
					});
				});
			});
		});
	}
	groupMarketsByName(markets) {
		return groupMarketsByName(markets)
	}

    makeBetbuilder() {
        this.betbuilder = this.betbuilder || BetBuilder.getBetbuilderEventCalculator(this.state.event);
        this.betbuilder.setState = () => {
            this.setState(this.state);
        }
        this.betbuilder.onComplete = () => {};
    }

	selectTab(tab) {
		if (tab.id == 'betbuilder')
			this.makeBetbuilder();
		this.setState({currentTab: tab.id});
	}
	isCurrentTab(tab) {
		return this.state.currentTab == tab.id;
	}
	isBetbuilder() {
		return this.state.currentTab == 'betbuilder';
	}
	getBetbuilderOdds() {
		return this.groupMarketsByName(this.betbuilder.mapMarkets(x => x))
	}
	canBetbuilder() {
		return this.state.sport.id == '/sport/1';
	}

	getTabs() {
		const tabs = (this.state.event.categories || [{id: -1, name: 'All'}]);
		if (!this.canBetbuilder())
			return tabs;
		
		const allIndex = tabs.findIndex(t => t.id == -1 || t.name == 'All');
		const betbuilderTab = {id: 'betbuilder', name: 'Betbuilder'};
		
		const newTabs = [...tabs];
		if (allIndex != -1) {
			newTabs.splice(allIndex + 1, 0, betbuilderTab);
		} else {
			newTabs.unshift(betbuilderTab);
		}
		
		return newTabs;
	}

	render({}) {
		const {sport, category, tournament, event, odds} = this.state;
		if (event == null)
			return null;
		
		return <Fragment>
			<P.EventHeader {...{sport, category, tournament}} onClose={() => {window.history.back()}} />
			<P.EventName>{event.home} - {event.away}</P.EventName>
			<P.EventInfoRow>
				<P.EventInfoCell>{new Date(event.date*1e3).toLocaleDateString()}</P.EventInfoCell>
				<P.EventInfoCell>{new Date(event.date*1e3).toLocaleTimeString()}</P.EventInfoCell>
			</P.EventInfoRow>
			<P.EventNameLarge event={event} />
			<P.TabsHScrollContainer>
				{this.getTabs().map(tab => {
					if (tab.id == 'betbuilder') {
						return <P.SpecialSingleEventTab selected={this.isCurrentTab(tab)} onClick={() => this.selectTab(tab)}>
							<Trans>Betbuilder</Trans>
						</P.SpecialSingleEventTab>
					}
					return <P.SingleEventTab selected={this.isCurrentTab(tab)} onClick={() => this.selectTab(tab)}>
						{tab.name}
					</P.SingleEventTab>
				})}
			</P.TabsHScrollContainer>
			{!this.isBetbuilder() 
				? <P.EventMarketsMarketGroup>
					{odds
						.filter(marketGroup => marketGroup.sub[0].categories.includes(this.state.currentTab))
						.map((marketGroup, idx) => <CollapsibleMarket key={this.state.currentTab+marketGroup.name} open={idx < 3} marketGroup={marketGroup} />)}
				</P.EventMarketsMarketGroup>
				: <P.EventMarketsMarketGroup>
					{this.getBetbuilderOdds()
						.map((marketGroup, idx) => <CollapsibleBetbuilderMarket key={this.state.currentTab+marketGroup.name} open={true} marketGroup={marketGroup} betbuilder={this.betbuilder} />)}
				</P.EventMarketsMarketGroup>}
			<P.FakeSeparator />
		</Fragment>;
	}
}

export function groupMarketsByName(markets) {
	const groups = {};
	for (let market of markets) {
		const hasOutcomesWithSpread = /^(.*?)( \(?-?[0-9]+([\.:-][0-9]+)\)?)$/.test(Object.values(market.sub || {0:{}})[0].name || '')
		const marketCleanName = !hasOutcomesWithSpread ? market.name : market.name.replace(/^(.*?)( \(?-?[0-9]+([\.:-][0-9]+)\)?)?$/, '$1');
		groups[marketCleanName] = groups[marketCleanName] || {
			name: marketCleanName,
			sub: []
		};
		groups[marketCleanName].sub.push(market);
	}
	const groupsList = Object.values(groups).sort((a, b) => a.sub[0].order - b.sub[0].order);
	return groupsList;
}

export class CollapsibleMarket extends Component {
	state = {
		open: false, 
		wasOpen: false
	};
	componentWillMount() {
		this.setState({
			open: !!this.props.open, 
			wasOpen: !!this.props.open
		})
	}
	render({marketGroup}) {
		return <P.MarketGroup>
			<P.MarketGroupHeader open={this.state.open} onClick={() => this.setState({open: !this.state.open, wasOpen: true})}>
				{marketGroup.name}
			</P.MarketGroupHeader>
			{this.state.wasOpen && <P.MarketCollapsingElem open={this.state.open}>
				{marketGroup.sub.map(market => <P.MarketGroupOdds cols={Object.keys(market.sub).length}>
					{Object.values(market.sub).map(outcome => {
						return <P.MarketGroupOddButton 
								   outcome={outcome} 
								   selected={Ticket.hasPrematchOdds(outcome.id)}
								   onClick={() => Ticket.togglePrematchOdds(outcome.id)} />
					})}
				</P.MarketGroupOdds>)}
			</P.MarketCollapsingElem>}
		</P.MarketGroup>
	}
}

export class CollapsibleBetbuilderMarket extends Component {
	state = {
		open: false, 
		wasOpen: false
	};
	componentWillMount() {
		this.setState({
			open: !!this.props.open, 
			wasOpen: !!this.props.open
		})
	}
	render({marketGroup, betbuilder}) {
		return <P.MarketGroup>
			<P.MarketGroupHeader open={this.state.open} onClick={() => this.setState({open: !this.state.open, wasOpen: true})}>
				{marketGroup.name}
			</P.MarketGroupHeader>
			{this.state.wasOpen && <P.MarketCollapsingElem open={this.state.open}>
				{marketGroup.sub.map(market => <P.MarketGroupOdds cols={Object.keys(market.sub).length}>
					{Object.values(market.sub).map(outcome => {
						return <P.MarketGroupBetbuilderButton 
							outcome={outcome} 
							selected={betbuilder.isOutcomeSelected(outcome)}
							disabled={betbuilder.isOutcomeDisabled(outcome)}
							onClick={() => betbuilder.toggleOdd(outcome).then(e => {
								betbuilder.addBetbuilderOdd();
							})}
					   />;
					})}
				</P.MarketGroupOdds>)}
			</P.MarketCollapsingElem>}
		</P.MarketGroup>
	}
}
